import { render, staticRenderFns } from "./ACreateTenant.vue?vue&type=template&id=612e6a98&"
import script from "./ACreateTenant.vue?vue&type=script&lang=js&"
export * from "./ACreateTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports